import { ComponentType } from 'react';
import { RouteObject } from 'react-router-dom';

/**
 * Base module configuration interface
 */
export interface ModuleConfig {
  /**
   * Unique module identifier (should match backend ModuleType enum)
   */
  id: string;

  /**
   * Display name of the module
   */
  name: string;

  /**
   * Short label for UI display
   */
  label: string;

  /**
   * Description of the module
   */
  description?: string;

  /**
   * Module version
   */
  version: string;
}

/**
 * Module route creator function signature
 */
export type ModuleRouteCreator = (
  ProtectedRoute: ComponentType<any>,
  LazyWrapper: ComponentType<any>,
  config?: any,
  ModuleProtectedRoute?: ComponentType<any>,
) => RouteObject[];

/**
 * Base module class that all feature modules should extend
 */
export abstract class BaseModule implements ModuleConfig {
  abstract id: string;
  abstract name: string;
  abstract label: string;
  abstract version: string;
  description?: string;

  /**
   * Create routes for this module
   */
  abstract createRoutes: ModuleRouteCreator;

  /**
   * Get module metadata
   */
  getMetadata(): ModuleConfig {
    return {
      id: this.id,
      name: this.name,
      label: this.label,
      description: this.description,
      version: this.version,
    };
  }
}

/**
 * Module instance interface for the registry
 */
export interface ModuleInstance {
  config: ModuleConfig;
  createRoutes: ModuleRouteCreator;
  isActive: boolean;
  settings?: any;
}
